export class PathHelper {
  static getName(path: string) {
    let normalized = PathHelper.normalize(path);
    if (normalized.includes("/")) {
      normalized = normalized.substr(normalized.lastIndexOf("/") + 1);
    }

    return normalized;
  }

  static join(...args): string {
    const normalized = args.map(m => {
      let name: string = PathHelper.normalize(m);

      if (name.startsWith("./")) {
        name = name.substr(2);
      }

      while (name.endsWith("/")) {
        name = name.substr(0, name.length - 1);
      }

      return name;
    }).filter(m => m && m !== "");

    let final = "";
    // let unit = null;

    for (let i = 0; i < normalized.length; i++) {
      const n = normalized[i];

      if (final !== "") {
        final += "/";
      }
      // else if (n.includes(":")) {
      //   unit = n;
      // }

      // if (n.startsWith("/")) {
      //   final = unit + "/" + n;
      // }
      // else 
      if (n.startsWith("/") || n.includes(":/")) {
        final = n;
      }
      else if (n.startsWith("./")) {
        final = n.substr(2);
      }
      else if (n.startsWith("../")) {
        if (final.includes("/")) {
          final = final.substr(0, final.lastIndexOf("/"));
        }
        final += n.substr(3);
      }
      else {
        final += n;
      }
    }

    return final;
  }

  static getAbsolutePath(path: string, cwd?: string) {
    /** @todo Get the absolute path */
    let finalPath = this.normalize(path);
    if (finalPath[0] !== "/") {
      finalPath = "/" + finalPath;
    }

    if (cwd && cwd.split("/")[0] && cwd.split("/")[0].includes(":") &&
      finalPath.startsWith("/")) {
      const unit = cwd.substr(0, cwd.indexOf(":") + 1);
      finalPath = unit + finalPath;
    }

    return finalPath;
  }

  static getExtension(path: string) {
    if (!path || path === "") {
      return "";
    }

    const format = path.substr(path.lastIndexOf(".") + 1).toLowerCase();
    return format;
  }

  static normalize(path: string): string {
    let finalPath = path;

    if (finalPath.endsWith("/")) {
      finalPath = finalPath.substr(0, finalPath.length - 1);
    }

    finalPath = finalPath
      .split("\\")
      .join("/")
      .split("/")
      // .filter(m => m && m.trim() !== "") /** @todo This is causing a bug (it deletes the first /) */
      .join("/");

    return finalPath;
  }
}
